import { gql } from '@apollo/client';

export const GET_COUNT_OF_REGISTERED_DEVICES = gql`
  query GetCountOfRegisteredDevices($dataContractName: String!, $fuzzySearch: Boolean!) {
    getCountOfRegisteredDevices(dataContractName: $dataContractName, fuzzySearch: $fuzzySearch) {
      count
    }
  }
`;
